import { Component, OnInit } from '@angular/core';
import { AmazingTimePickerService } from '@jonijnm/amazing-time-picker';
import { validateTime } from '@library/common/functions';
import { BreakpointService } from '@library/core';
import { Observable, of } from 'rxjs';
import { ScheduleReportService } from '../schedule-report.service';
import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { RelativeDateService } from '@library/common';
import { DaysList, MonthList, RecurrenceTypes } from '../schedule-report';

@Component({
  selector: 'lib-recurrence',
  templateUrl: './recurrence.component.html',
  styleUrls: ['./recurrence.component.scss'],
})
export class RecurrenceComponent implements OnInit {

  days$: Observable<any> = of(DaysList);
  monthlyDays$: Observable<any[]> = of(MonthList);
  daySelected: any = [];
  datePlaceholder = 'MM/DD/YYYY';
  today = new Date();
  // frequencyList: any = [];
  // frequencySelected: any = '';
  primaryColor = 'primary';
  selectedColor = 'accent';
  dates = ['endDate', 'startDate'];
  monthlyDaysSelected: number[] = [];

  validateTime = validateTime;

  constructor(
    private atp: AmazingTimePickerService,
    public scheduleReport: ScheduleReportService,
    public breakpoints: BreakpointService,
    public relativeDates: RelativeDateService,
  ) { }

  ngOnInit(): void {
    // this.monthlyDays$ = of(Array.from({ length: 31 }, (_, i) => i + 1));

    this.dates.map(d => this.scheduleReport.scheduleForm.get(d))
      .map(c => {
        if (c.value) {
          c.patchValue(this.relativeDates.getIsoDate(c.value));
          c.markAsTouched();
        }
        // c.value ? c.patchValue( this.relativeDates.getIsoDate( c.value )) : c;
      });
    // this.updateAllFields();

    // this.monthlyDays = Array.from({ length: 31 }, (_, i) => i + 1);

    this.scheduleReport.recTypeSelected$.subscribe(rec => {
      // const form = this.scheduleReport.scheduleForm;
      if (rec == RecurrenceTypes[0]) {
        // form.get('frequency_week').reset([]);
        this.monthlyDaysSelected = [];
        this.scheduleReport.frequency_week = [];
        this.scheduleReport.frequency_month = [];
        this.scheduleReport.scheduleForm.get('frequency_month').clearValidators();
        this.scheduleReport.scheduleForm.get('frequency_month').updateValueAndValidity();
        this.scheduleReport.scheduleForm.get('frequency_week').clearValidators();
        this.scheduleReport.scheduleForm.get('frequency_week').updateValueAndValidity();
      } else if (rec == RecurrenceTypes[1]) {
        this.monthlyDaysSelected = [];
        this.scheduleReport.frequency_month = [];
        this.scheduleReport.scheduleForm.get('frequency_month').clearValidators();
        this.scheduleReport.scheduleForm.get('frequency_month').updateValueAndValidity();
        this.scheduleReport.scheduleForm.get('frequency_week').setValidators([Validators.required])
        this.scheduleReport.scheduleForm.get('frequency_week').updateValueAndValidity();
      } else if (rec == RecurrenceTypes[2]) {
        // this.daySelected = [];
        // form.get('frequency_week').reset([]);
        // form.get('everyday').reset(false);
        this.scheduleReport.frequency_week = [];
        this.monthlyDaysSelected = this.scheduleReport.frequency_month;
        this.scheduleReport.scheduleForm.get('frequency_week').clearValidators();
        this.scheduleReport.scheduleForm.get('frequency_week').updateValueAndValidity();
        this.scheduleReport.scheduleForm.get('frequency_month').setValidators([Validators.required])
        this.scheduleReport.scheduleForm.get('frequency_month').updateValueAndValidity();
      }

      if (this.scheduleReport.no_end_date) {
        this.setNoEnd(this.scheduleReport.no_end_date);
      }

      if (this.scheduleReport.startTime) {
        this.scheduleReport.startTime = this.roundToNearestFiveMinutes(this.scheduleReport.startTime);
      }

    })

    this.scheduleReport.scheduleForm.get('startTime').setValidators([this.timeValidation()])
  }

  openClock(field: string): void {
    let f = this.scheduleReport.scheduleForm.get(field);
    let time = f.value || '00:00';

    if (!this.validateTime(f.value)) { time = '00:00'; }

    const timepicker = this.atp.open({ time });
    if (timepicker) {
      timepicker.afterClose()
        .subscribe(t => {
          let roundedTime = this.roundToNearestFiveMinutes(t);
          f.setValue(roundedTime)
        });
    }
  }

  roundToNearestFiveMinutes(time: string): string {
    let timeParts = time.split(':');

    let hours = parseInt(timeParts[0]);
    let minutes = parseInt(timeParts[1]);

    // Round minutes to nearest 5
    minutes = Math.round(minutes / 5) * 5;
    if (minutes === 60) {
      minutes = 0;
      hours++;
    }

    // Format hours and minutes
    let formattedHours = hours < 10 ? '0' + hours : hours.toString();
    let formattedMinutes = minutes < 10 ? '0' + minutes : minutes.toString();

    return `${formattedHours}:${formattedMinutes}`;
  }

  setNoEnd(value: any) {
    this.scheduleReport.no_end_date = value;
    if (this.scheduleReport.no_end_date) {
      this.scheduleReport.scheduleForm.get('endDate').clearValidators();
      this.scheduleReport.scheduleForm.get('endDate').setValue('');
      this.scheduleReport.scheduleForm.get('endDate').markAsUntouched();
    } else {
      this.scheduleReport.scheduleForm.get('endDate').setValidators([Validators.required])
    }
    this.scheduleReport.scheduleForm.get('endDate').updateValueAndValidity();

  }

  formatTime(time: string, field: string): string {
    if (!time) { return; }
    if (time.length === 1) { time = '0' + time; }
    if (time.length === 2) { time = time + '00'; }
    if (time.length === 3) { time = '0' + time; }

    time = this.roundToNearestFiveMinutes(time);

    const match = time.match(/^([\d]{2}):?([\d]{2})$/);
    if (match) {
      time = match[1] + ':' + match[2];
      this.scheduleReport.scheduleForm.get(field).setValue(time);
    }

    return time;
  }

  updateDateFields() {
    let fields = ['endDate', 'startDate'];

    for (let field of fields) {
      this.scheduleReport.scheduleForm.get(field).updateValueAndValidity({ onlySelf: true, emitEvent: true });
    }
  }

  toggleDate(date: number) {
    const index = this.monthlyDaysSelected.indexOf(date);
    if (index === -1) {
      this.monthlyDaysSelected.push(date);
    } else {
      this.monthlyDaysSelected.splice(index, 1);
    }

    this.scheduleReport.frequency_month = this.monthlyDaysSelected;
  }

  isDateSelected(date: number): boolean {
    return this.monthlyDaysSelected.includes(date);
  }

  clearAll() {
    if (this.scheduleReport.types == "monthly") {
      this.monthlyDaysSelected = [];
      this.scheduleReport.frequency_month = this.monthlyDaysSelected;

    } else {
      this.daySelected = [];
      this.scheduleReport.frequency_week = this.daySelected;
    }
  }

  timeValidation(): ValidatorFn {
    const TimeRegEx = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
    return (control: AbstractControl): ValidationErrors | null => {
      const startTime = control.value;
      
      if (!startTime?.match(TimeRegEx)) {
        return { dateTimeFilter: true };
      }
      return null;
    };
  }
}
